import { TsmApi } from 'tsmapi';

// TOOD: Should it live here?
const config = {
    debug: false
}

const acsStore = {
    api: new TsmApi('/rest/tsmrestapiproxy')
}

const store = {
    addStore(storeName, storeObject) {
        this[storeName] = storeObject;
        storeObject.rootStore = this;
    }
}

window.rootStore = store;  // TODO: Remove this line.
store.addStore('acsStore', acsStore);
store.addStore('config', config);
export default store;
